import { http } from 'connex-cds';

export default {
  listApps: () => http.get({ apiName: 'admin', path: `/apps?activeOnly=false` }),
};
